import {
  addYears,
  endOfMonth,
  endOfYear,
  isValid,
  max as maxDate,
  min as minDate,
  startOfMonth,
  startOfYear,
  subYears,
} from 'date-fns';

/** Years either side of today a date picker's month/year dropdowns can reach. */
export const DATE_PICKER_YEARS_BACK = 100;
export const DATE_PICKER_YEARS_AHEAD = 100;

export interface NavMonths {
  startMonth: Date;
  endMonth: Date;
}

export interface NavMonthsOptions {
  yearsBack?: number;
  yearsAhead?: number;
}

/**
 * The months a `captionLayout="dropdown"` calendar can navigate between.
 *
 * Without an explicit range react-day-picker only offers the current year, so
 * the year dropdown cannot leave it. The window spans a band of years either
 * side of today, stretched to cover any anchor dates that fall outside it so a
 * date already in view stays reachable.
 */
export function getNavMonths(
  anchors?: Date | ReadonlyArray<Date | null | undefined>,
  { yearsBack = DATE_PICKER_YEARS_BACK, yearsAhead = DATE_PICKER_YEARS_AHEAD }: NavMonthsOptions = {},
): NavMonths {
  const today = new Date();
  const starts = [startOfYear(subYears(today, yearsBack))];
  const ends = [endOfYear(addYears(today, yearsAhead))];

  const anchorList = Array.isArray(anchors) ? anchors : anchors ? [anchors] : [];
  for (const anchor of anchorList) {
    if (!anchor || !isValid(anchor)) continue;
    starts.push(startOfMonth(anchor));
    ends.push(endOfMonth(anchor));
  }

  return { startMonth: minDate(starts), endMonth: maxDate(ends) };
}
